import React, { useContext, useEffect, useState } from "react";

import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import FooterC from "../components/FooterC";
import { useHistory, useLocation } from "react-router-dom";
import saveLog from "../services/saveLog";
import ClientNavbar from "../components/ClientNavbar";
import ConsultantNavbar from "../components/ConsultantNavbar";
import { ContextApi } from "../App";

function Dashboard({
  children,
  title,
  setSearchText,
  setCurrent,
  setDefaultDate,
  fetchData,
  consultantDataCount,
  csvData,
}) {
  const { setIsMenuExpanded, isMenuExpanded } = useContext(ContextApi);
  const history = useHistory();
  const location = useLocation();

  if (title === undefined) {
    title = "";
  }
  useEffect(() => {
    if (title === "") {
      document.title = "HR Management Software";
    } else {
      document.title = title + " | HR Management Software";
    }
  }, []);

  useEffect(() => {
    const uri = location.pathname;
    saveLog("PAGE_VISIT", `Visited '${title}' (${uri})`);
  }, []);

  const pathCheck = [
    "/clientdashboard",
    "/upcominginterviews",
    "/completedinterviews",
    "/upcominginterviewdetail",
    "/pendinginterviews",
  ];
  const path = history.location.pathname;
  const checkpath = pathCheck.includes(path);

  const consultantPathCheck = [
    "/consultantdashboard",
    "/selectedcandidates",
    "/joinedcandidates",
    "/pendingcandidates",
    "/rejectedcandidates",
    "/inactivecandidate",
    "/newcandidates",
  ];
  const consultantPath = history.location.pathname;
  const checkConsultantPath = consultantPathCheck.includes(consultantPath);

  return (
    <div id="wrapper">
      <div
        id="content-wrapper"
        className={`d-flex flex-column ${isMenuExpanded ? "expand_menu" : ""}`}
      >
        <div id="content">
          {/* {checkpath === true ? <ClientNavbar /> : <Navbar title={title} />} */}
          {checkpath === true ? (
            <ClientNavbar />
          ) : checkConsultantPath ? (
            <ConsultantNavbar
              setDefaultDate={setDefaultDate}
              setCurrent={setCurrent}
              setSearchText={setSearchText}
              fetchData={fetchData}
              consultantDataCount={consultantDataCount}
              csvData={csvData}
            />
          ) : (
            <Navbar
              isMenuExpanded={isMenuExpanded}
              setIsMenuExpanded={setIsMenuExpanded}
              title={title}
            />
          )}
          <div className="container-fluid">{children}</div>
        </div>
        <FooterC />
      </div>
    </div>
  );
}

export default Dashboard;
